import * as React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Theme,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { FormSelectChoice, KeyValue } from "../interfaces";
import { Form } from "../interfaces";
import { visuallyHidden } from "@mui/utils";

export interface Props {
  currentValue: string | null;
  fieldName: string;
  options: FormSelectChoice[];
  uiValue?: boolean;
  updateFilter?: (field: string, value: string, uiValue?: boolean) => void;
  form?: Form;
  setForm?: (object: any) => void;
  label?: string;
  id?: string;
  noEmptyVal?: boolean;
  arrayOfVals?: boolean;
  helperText?: string;
  // If there are any additional on change occurrences that needs to happen beyond setting the form,
  // it can be passed in as a prop here (onChange)
  onChange?: (e: any) => void;
  disabled?: boolean;
  disabledOptions?: string[];
  error?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  labelStyles: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main,
  },
}));

function SelectFilterField({
  currentValue,
  label,
  id,
  fieldName,
  options,
  form,
  noEmptyVal,
  uiValue,
  arrayOfVals,
  setForm,
  onChange,
  updateFilter,
  disabled,
  disabledOptions,
  error,
  helperText,
}: Props) {
  const classes = useStyles();
  const handleChange = (event: any) => {
    const value = arrayOfVals
      ? event.target.value.split(",")
      : event.target.value;
    if (form && setForm) {
      setForm({ ...form, [fieldName]: value });
    }
    if (updateFilter) {
      updateFilter(fieldName, value, uiValue);
    }
    if (onChange) {
      onChange(event);
    }
  };
  const inputLabel = label ? label : fieldName;
  const inputId = id ? id : fieldName;
  return (
    <FormControl
      error={error}
      variant="outlined"
      fullWidth
      size="small"
      margin="dense"
    >
      <Typography variant={label ? "body1" : undefined}>
        <InputLabel
          shrink={noEmptyVal}
          className={disabled ? classes.labelStyles : undefined}
          htmlFor={`select-filter-${inputId}`}
          id={`select-filter-${inputId}-label`}
          sx={!label ? visuallyHidden : {}}
        >
          {(currentValue && currentValue !== "") || disabled
            ? inputLabel
            : `Select ${inputLabel}`}
        </InputLabel>
      </Typography>
      <Select
        native
        disabled={disabled}
        labelId={`select-filter-${inputId}-label`}
        id={`select-filter-${inputId}`}
        value={currentValue}
        onChange={e => handleChange(e)}
        label={label}
      >
        {label && !noEmptyVal ? (
          <option value="">{disabled ? label : `Select ${label}`}</option>
        ) : (
          ""
        )}
        {options.map((option: KeyValue, int: number) => (
          <option
            key={`${option.value}_${int}`}
            value={option.value}
            disabled={
              disabledOptions
                ? disabledOptions.includes(option.value) &&
                  currentValue !== option.value &&
                  option.value
                : false
            }
          >
            {option.label}
          </option>
        ))}
      </Select>
      {helperText ? (
        <FormHelperText style={{ color: "#CC0000" }}>
          {helperText}
        </FormHelperText>
      ) : (
        ""
      )}
    </FormControl>
  );
}

export default SelectFilterField;
